module.exports = __webpack_public_path__ + "static/img/box-frequency.9fc914c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/box-frequency.svg
 ** module id = 561
 ** module chunks = 1
 **/